import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, useScreenClass } from '@vp/swan';
import { ReplaceTokens, useTranslations } from '@vp/om-translations';
import useSiteData from '../../hooks/useSiteData';
import useIdentityContext from '../../hooks/useIdentityContext';
import CheckMarkCircle from '../shared/icons/CheckMarkCircleIcon';
import { OrderHistoryLink } from '../shared/AnonErrorHandler';

const OrderConfirmationPanel = ({ email }) => {
  const [orderConfirmationMessages] = useTranslations([
    'orderConfirmationMessages',
  ]);
  const { identity } = useIdentityContext();
  const { isAnonymousUser } = identity;
  const { externalAppNavigation: nav } = useSiteData();
  const { orderHistory } = nav;
  const screenClass = useScreenClass();
  const checkIconSize = screenClass === 'xs' ? 32 : 48;

  return (
    <>
      {/* This aria hidden heading is intended for those viewing the visual UI
and is hidden from assistive tech to prevent redundancy 
since we also render a visually hidden heading at the top of the page */}
      <Typography fontSize="x4large" fontWeight="bold" aria-hidden>
        <ReplaceTokens
          tokenizedString={orderConfirmationMessages.titleMessage}
          substitutions={{
            lineBreak: <br />,
          }}
        />
        <Box component="span" ml={3}>
          <CheckMarkCircle
            fill="#44a2dd"
            width={checkIconSize}
            height={checkIconSize}
          />
        </Box>
      </Typography>
      {email && orderHistory && !isAnonymousUser && (
        <Typography mt={7}>
          <ReplaceTokens
            tokenizedString={orderConfirmationMessages.tagline}
            substitutions={{ email, OrderHistoryLink }}
          />
        </Typography>
      )}
    </>
  );
};

OrderConfirmationPanel.propTypes = {
  email: PropTypes.string.isRequired,
};

export default OrderConfirmationPanel;
